import {Link, styled} from '@mui/material';

const StyledLink = styled(Link)`
	color: ${({theme}) => theme.colors.brand.primary.blue};
	font-size: 0.75rem;
	font-weight: 600;
	line-height: 1rem;
	cursor: pointer;
`;

export {StyledLink};
